import CodeBlock, { type CodeBlockOptions } from '@tiptap/extension-code-block';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { type BundledLanguage, type BundledTheme } from 'shiki';

import { CodeBlockView } from './CodeBlockView.tsx';
import { ShikiPlugin } from './shiki-plugin.ts';

export interface CodeBlockShikiOptions extends CodeBlockOptions {
  defaultLanguage: BundledLanguage | null | undefined;
  defaultTheme: BundledTheme;
  themes:
    | {
        light: BundledTheme;
        dark: BundledTheme;
      }
    | null
    | undefined;
}

export const CodeBlockShiki = CodeBlock.extend<CodeBlockShikiOptions>({
  // @ts-ignore
  addOptions() {
    return {
      ...this.parent?.(),
      defaultLanguage: null,
      defaultTheme: 'github-dark',
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(CodeBlockView);
  },

  addProseMirrorPlugins() {
    return [
      ...(this.parent?.() || []),
      ShikiPlugin({
        name: this.name,
        defaultLanguage: this.options.defaultLanguage,
        defaultTheme: this.options.defaultTheme,
        themes: this.options.themes,
      }),
    ];
  },
});
